import { Fragment } from "react";
import ProxyLayouts from "layouts/ProxyLayouts";
import Hero from "container/proxy/socks/Hero";
import Features from "container/proxy/socks/Features";
import PricingPlan from "container/proxy/residential/PricingPlan";
import Testimonial from "container/home/Testimonial";
import BuyProxies from "container/home/BuyProxies";

const SOCKSv5Proxy = () => {
    return (
        <Fragment>
            <Hero />
            <Features titleSize="tablet:!text-[48px] tablet:!leading-[64.8px]" />
            <PricingPlan />
            <Testimonial />
            <BuyProxies />
        </Fragment>
    );
};

export default SOCKSv5Proxy;